angular.module('impactx.relationView', []);